import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchMrdList = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdListDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL, payload);
};

export const apiFetchInactiveMrdList = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdListDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      inactive: true,
    },
  });
  return axios.get(serviceURL, payload);
};

export const apiFetchActiveMrdTypes = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getDeviceTypes',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      status: 'active',
    },
  });
  return axios.get(serviceURL, payload);
};

export const apiFetchMrdStatuses = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getDeviceStatusesDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL, payload);
};

export const apiFetchPostalOperatorList = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getPostalOperatorList',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL, payload);
};

export const apiFetchInboundDataLocationList = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getDataLocationListDefault',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      dataLocationType: 'I',
    },
  });
  return axios.get(serviceURL, payload);
};
